import { createClient } from '@supabase/supabase-js';

// Initialize Supabase client
const supabaseUrl = 'https://jlukxfltibmxaonhripo.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpsdWt4Zmx0aWJteGFvbmhyaXBvIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTcyOTYwOTI0NiwiZXhwIjoyMDQ1MTg1MjQ2fQ.azWLdoVXRgEggw9XoGQJUecPAzqxlg4rdP0LkBZpI3w';
const supabase = createClient(supabaseUrl, supabaseAnonKey);

// 💰 Grantmaking Programs

// export const fetchGrantmakingProgramsFromSupabase = async () => {
//     console.log("Fetching grantmaking programs from Supabase.");
//     try {
//         const { data, error } = await supabase
//             .from('grantmaking_programs')
//             .select('*')
//             .eq('is_donor_advised_fund', false);
//         if (error) {
//             throw error;
//         }
//         return data;
//     } catch (error) {
//         console.error("Error fetching grantmaking programs from Supabase:", error);
//         throw error;
//     }
// };

// export const fetchSingleGrantMakingProgramFromSupabase = async (programId) => {
//     console.log("Searching for single grantmaking program in Supabase for ID: ", programId);
//     try {
//         const { data, error } = await supabase
//             .from('grantmaking_programs')
//             .select('*')
//             .eq('id', programId);
//         if (error) {
//             throw error;
//         }
//         console.log("Single grantmaking program from Supabase:", data[0]);
//         return data[0];
//     } catch (error) {
//         console.error("Error searching for single grantmaking program in Supabase:", error);
//         throw error;
//     }
// }


// 💰 Awards

export const fetchAwardsReceivedFromSupabase = async (selectedOrganizationEin) => {
    // console.log("Fetching awards from Supabase for organization EIN: ", selectedOrganizationEin);
    try {
        const { data, error } = await supabase
            .from('awards') // Updated table name to 'awards'
            .select('*')
            .eq('recipient_ein', selectedOrganizationEin); // Updated column and parameter

        if (error) {
            throw error;
        }
        console.log("Awards from Supabase:", data);
        return data; // Return the fetched data
    } catch (error) {
        console.error("Error fetching awards from Supabase:", error);
        throw error;
    }
};


export const fetchAwardsGrantedFromSupabase = async (selectedOrganizationEin) => {
    // console.log("Fetching awards granted from Supabase for organization EIN: ", selectedOrganizationEin);
    try {
        const { data, error } = await supabase
            .from('awards') // Updated table name to 'awards'
            .select('*, ntee_codes!inner(*)') // Added join with ntee_codes
            .eq('funder_ein', selectedOrganizationEin); // Updated column and parameter

        if (error) {
            throw error;
        }
        console.log("Awards granted from Supabase:", data);
        return data; // Return the fetched data
    } catch (error) {
        console.error("Error fetching awards granted from Supabase:", error);
        throw error;
    }
};

export const fetchRelevantAwardsForMonthlyZip = async (startDate, endDate, nteeFull, stateAbbreviationCd, minAmount = null, maxAmount = null, page = 0, pageSize = 500) => {
    console.log(`Fetching awards with filters: StartDate=${startDate}, EndDate=${endDate}, NTEE=${nteeFull}, State=${stateAbbreviationCd}, MinAmount=${minAmount}, MaxAmount=${maxAmount}, Page=${page}, PageSize=${pageSize}`);

    if (nteeFull) {
        const nteeMajor = nteeFull[0]

        try {
            // First query: get awards
            let query = supabase
                .from('awards')
                .select('*, ntee_codes!inner(*)')
                .eq('ntee_codes.ntee_major', nteeMajor)
                .range(page * pageSize, (page + 1) * pageSize - 1);

            // Parse start and end dates
            const [startYear, startMonth] = startDate.split('-').map(Number);
            const [endYear, endMonth] = endDate.split('-').map(Number);

            // Filter by date range
            // For single month range, use exact match
            if (startYear === endYear && startMonth === endMonth) {
                query = query
                    .eq('zip_year', startYear)
                    .eq('zip_month', startMonth);
            } else {
                // For multi-month range, use range filters
                query = query
                    .gte('zip_year', startYear)
                    .lte('zip_year', endYear);
                
                // Additional month filtering for edge cases
                if (startYear === endYear) {
                    // Same year, filter by month range
                    query = query
                        .gte('zip_month', startMonth)
                        .lte('zip_month', endMonth);
                } else {
                    // Different years, need to handle month boundaries
                    query = query.or(
                        `and(zip_year.eq.${startYear},zip_month.gte.${startMonth}),` +
                        `and(zip_year.eq.${endYear},zip_month.lte.${endMonth}),` +
                        `and(zip_year.gt.${startYear},zip_year.lt.${endYear})`
                    );
                }
            }

            // Add optional state filter
            if (stateAbbreviationCd) {
                query = query.eq('state_abbreviation_cd', stateAbbreviationCd);
            }
    
            // Add optional amount filters
            if (minAmount !== null) {
                query = query.gte('cash_grant_amt', minAmount);
            }
            if (maxAmount !== null) {
                query = query.lte('cash_grant_amt', maxAmount);
            }
    
            // Add timeout handling
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => reject(new Error('Query timeout after 60 seconds')), 60000);
            });
    
            const { data: awardsData, error: awardsError } = await Promise.race([query, timeoutPromise]);
    
            if (awardsError) {
                throw awardsError;
            }

            // Second query: get 990s data for the funder EINs
            const funderEins = [...new Set(awardsData.map(award => award.funder_ein))];
            
            const { data: form990sData, error: form990sError } = await supabase
                .from('form_990s')
                .select('*')
                .in('ein', funderEins);

            if (form990sError) {
                throw form990sError;
            }

            // Merge the data
            const form990sMap = {};
            form990sData.forEach(form990 => {
                if (!form990sMap[form990.ein]) {
                    form990sMap[form990.ein] = form990; // Store single latest instead of array
                } else {
                    // Compare tax_year strings and keep the latest
                    const currentYear = parseInt(form990sMap[form990.ein].tax_year);
                    const newYear = parseInt(form990.tax_year);
                    if (newYear > currentYear) {
                        form990sMap[form990.ein] = form990;
                    }
                }
            });

            const mergedData = awardsData.map(award => ({
                ...award,
                form_990: form990sMap[award.funder_ein] || null // Single object instead of array
            }));

            console.log(`Successfully fetched ${mergedData.length} awards (page ${page + 1})`);
            return mergedData;
        } catch (error) {
            console.error('Error fetching awards:', error);
            throw error;
        }
    } else {
        console.log("No NTEE full provided. Skipping fetch.");
        return [];
    }
};

// 📄 990s / Organization Info

export const fetchLatest990FromSupabase = async (selectedOrganizationEin) => {
    if (!selectedOrganizationEin) {
        console.log("fetchLatest990FromSupabase() called, but selectedOrganizationEin not set. Skipping fetch.");
        return null;
    }            
    try {
        console.log("Fetching latest 990 from Supabase for given FilerEin.");
        const { data, error } = await supabase
            .from('form_990s')
            .select('*')
            .eq('ein', selectedOrganizationEin)
            .order('return_ts', { ascending: false })
            .limit(1);
        if (error) {
            console.log("No matching 990 found.");
            return null;
        }
        const latest990 = data[0];
        console.log("Latest 990 from Supabase:", latest990);
        return latest990;
    } catch (error) {
        console.error("Error fetching latest 990 from Supabase:", error);
        return null;
    }
};

export const searchForOrganizationsInSupabase = async (searchTerm) => {
    console.log("Searching for organizations in Supabase for term: ", searchTerm);
    
    // Check if the search term is empty or only contains spaces
    if (!searchTerm || searchTerm.trim() === '') {
        console.error("Search term is empty or only contains spaces.");
        return []; // Return an empty array or handle as needed
    }

    // Replace spaces with '+' to allow for multi-word search terms
    const formattedSearchTerm = searchTerm.replace(/\s+/g, '+').trim();
    console.log("Formatted search term:", formattedSearchTerm);

    try {
        const { data, error } = await supabase
            .from('form_990s')
            .select()
            .textSearch('business_name', formattedSearchTerm);

        if (error) {
            throw error;
        }
        console.log("Organizations from Supabase:", data);
        return data;
    } catch (error) {
        console.error("Error searching for organizations in Supabase:", error);
        throw error;
    }
}